module.exports = __webpack_public_path__ + "media/images/help/scoring-run-result-2-ba46a6e7d5cc4c7b4d180400471cfbb7.png";